export default "__VITE_ASSET__C3NxZbe1__"